import React, { useEffect, useState } from "react";
import * as Icons from "lucide-react";
import { toast } from "sonner";
import { useLang } from "../../contexts/LanguageContext";
import { api } from "../../lib/api";

const ServicesManager = () => {
  const { t } = useLang();
  const [services, setServices] = useState([]);

  const load = async () => { const { data } = await api.get("/admin/services"); setServices(data); };
  useEffect(() => { load(); }, []);

  const update = (id, field, value) => {
    setServices((arr) => arr.map((s) => (s.id === id ? { ...s, [field]: value } : s)));
  };

  const save = async (s) => {
    try {
      await api.put(`/admin/services/${s.id}`, {
        title_tr: s.title_tr, title_en: s.title_en,
        description_tr: s.description_tr, description_en: s.description_en,
        icon: s.icon, visible: s.visible,
      });
      toast.success(t.admin.saved);
    } catch (e) { toast.error(e?.response?.data?.detail || "Error"); }
  };

  return (
    <div data-testid="admin-services">
      <h1 className="font-display" style={{ fontSize: "2.5rem", fontWeight: 300, color: "var(--warm-off-white)", marginBottom: 24 }}>{t.admin.nav.services}</h1>
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        {services.map((s) => {
          const Icon = Icons[s.icon] || Icons.Sparkles;
          return (
            <div key={s.id} style={{ background: "var(--rich-black-light)", border: "1px solid rgba(139,32,53,0.25)", padding: 24 }}>
              <div className="flex items-start" style={{ gap: 24, marginBottom: 16 }}>
                <div style={{ width: 48, height: 48, display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid rgba(201,151,58,0.4)", color: "var(--gold)", flexShrink: 0 }}>
                  <Icon size={20} />
                </div>
                <div style={{ flex: 1 }}>
                  <span className="font-mono" style={{ fontSize: "0.65rem", letterSpacing: "0.18em", color: "var(--gold)", textTransform: "uppercase" }}>{s.key}</span>
                  <div className="grid" style={{ gridTemplateColumns: "1fr 1fr", gap: 16, marginTop: 12 }}>
                    <input className="input-line" value={s.title_tr} onChange={(e) => update(s.id, "title_tr", e.target.value)} placeholder="Title TR" />
                    <input className="input-line" value={s.title_en} onChange={(e) => update(s.id, "title_en", e.target.value)} placeholder="Title EN" />
                    <textarea className="input-line" value={s.description_tr} rows={2} onChange={(e) => update(s.id, "description_tr", e.target.value)} placeholder="Description TR" />
                    <textarea className="input-line" value={s.description_en} rows={2} onChange={(e) => update(s.id, "description_en", e.target.value)} placeholder="Description EN" />
                    <input className="input-line" value={s.icon} onChange={(e) => update(s.id, "icon", e.target.value)} placeholder="Icon (lucide name)" />
                    <label className="font-mono" style={{ display: "flex", alignItems: "center", gap: 8, color: "rgba(248,244,240,0.7)", fontSize: "0.8rem" }}>
                      <input type="checkbox" checked={s.visible} onChange={(e) => update(s.id, "visible", e.target.checked)} /> Visible
                    </label>
                  </div>
                </div>
              </div>
              <button data-testid={`service-save-${s.key}`} onClick={() => save(s)} className="font-mono" style={{ padding: "10px 20px", background: "var(--gold)", color: "var(--rich-black)", border: "none", fontSize: "0.7rem", letterSpacing: "0.2em", textTransform: "uppercase", cursor: "pointer" }}>{t.admin.save}</button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ServicesManager;
